const header = {
	body: document.querySelector('body'),
	header: document.querySelector('.js-header'),
	headerActive: 'header--active',
	headerSticky: 'header--sticky',
	headerScroll: 'header--scroll',
	lastScrollTop: 2,
	headerTop: document.querySelector('.js-header-top'),
	navItems: document.querySelectorAll('.js-nav-item'),
	navDropdown: document.querySelector('.js-nav__dropdown'),
	headerTopActive: 'nav__item--active',
	active: 'active',
	nav: document.querySelector('.js-nav'),
	child: 'nav__item--has-children',
	scrollOverlay: 'scroll-overlay',
	megamenus: document.querySelectorAll('.js-megamenu'),
	mobileMenuBtn: document.querySelector('.js-mobile-menu-btn'),
	mobileMenuBtnActiveClass: 'header__button--active',
	navOpennedClass: 'nav--openned',
	primaryNavLink: document.querySelectorAll('.js-nav-link'),
	href: window.location.pathname,
	overlay: 'overlay',
	topScroll: 0,
	isScrollDisabled: false,
	disabledScrollClass: 'scroll-overlay',

	init: function() {
		this.checkInitialScroll();
		this.openMegamenu();
		this.stickyHeader();
		this.closeMegamenu();
		if (this.mobileMenuBtn) {
			this.toggleMobileMenu();
		}
		this.checkPage();
	},

	checkInitialScroll: function() {
		const scrollPosition =
			window.scrollY || document.documentElement.scrollTop;
		if (scrollPosition > 0) {
			this.header.classList.add(this.headerScroll);
			this.header.classList.remove(this.headerSticky);
		}
	},

	openMegamenu: function() {
		this.navItems.forEach((item) => {
			item.addEventListener('click', () => {
				if (item.classList.contains(this.child)) {
					item.classList.toggle(this.headerTopActive);
					const dropdown = item.querySelector('.nav__dropdown');
					dropdown.classList.toggle('active');

					if (
						this.header.classList.contains(this.headerScroll) &&
						dropdown.classList.contains('active')
					) {
						this.header.classList.add(this.overlay);
					} else if (
						this.header.classList.contains(this.headerScroll) &&
						!dropdown.classList.contains('active')
					) {
						this.header.classList.remove(this.overlay);
					}

					if (window.innerWidth <= 1200) {
						dropdown.style.maxHeight = dropdown.classList.contains(
							'active'
						)
							? `${dropdown.scrollHeight}px`
							: '0';
						this.closeOtherDropdowns(item);
					}
				}
			});
		});
	},

	closeMegamenu: function() {
		this.navItems.forEach((item) => {
			document.addEventListener('click', (event) => {
				if (!item.contains(event.target)) {
					this.closeDropdown(item);
				}

				const isOutsideMegaMenu = !event.target.closest('.js-nav-item');
				if (isOutsideMegaMenu) {
					this.header.classList.remove(this.overlay);
				}
			});
			document.addEventListener('keydown', (event) => {
				if (event.key === 'Escape') {
					this.closeDropdown(item);
					this.header.classList.remove(this.overlay);
				}
			});
			window.addEventListener('scroll', () => {
				if (this.header.classList.contains(this.headerScroll)) {
					this.closeDropdown(item);
					this.header.classList.remove('overlay');
				}
			});
		});
	},

	closeDropdown: function(item) {
		item.classList.remove(this.headerTopActive);
		const dropdown = item.querySelector('.nav__dropdown');
		dropdown.classList.remove('active');
		if (window.innerWidth <= 1200) {
			dropdown.style.maxHeight = '0';
		}
	},

	closeOtherDropdowns: function(clickedItem) {
		this.navItems.forEach((item) => {
			if (item !== clickedItem) {
				const dropdown = item.querySelector('.nav__dropdown');
				dropdown.classList.remove('active');
				dropdown.style.maxHeight = '0';
			}
		});
	},

	toggleMobileMenu: function() {
		this.mobileMenuBtn.addEventListener('click', () => {
			if (!this.nav.classList.contains(this.navOpennedClass)) {
				this.header.classList.add(this.headerActive);
				this.nav.classList.add(this.navOpennedClass);
				this.mobileMenuBtn.classList.add(this.mobileMenuBtnActiveClass);
				if (!this.isScrollDisabled) {
					this.topScroll = document.documentElement.scrollTop;
					this.body.style.top = `-${this.topScroll}px`;
					this.body.classList.add(this.disabledScrollClass);
					this.isScrollDisabled = true;
				}
			} else {
				this.nav.classList.remove(this.navOpennedClass);
				this.mobileMenuBtn.classList.remove(
					this.mobileMenuBtnActiveClass
				);
				this.header.classList.remove(this.headerActive);
				setTimeout(() => {
					this.megamenus.forEach((menu) => {
						menu.classList.remove(this.menuOpennedClass);
					});
				}, 300);
				this.body.removeAttribute('style');
				this.body.classList.remove(this.disabledScrollClass);
				document.documentElement.scrollTop = this.topScroll;
				this.isScrollDisabled = false;
			}
		});
	},

	stickyHeader: function() {
		window.addEventListener('scroll', () => {
			const currentScroll =
				window.pageYOffset || document.documentElement.scrollTop;
			const scrollPosition = window.scrollY;
			if (currentScroll < 3) {
				this.header.classList.remove(this.headerSticky);
			} else if (currentScroll > this.lastScrollTop) {
				this.header.classList.remove(this.headerSticky);
			} else if (currentScroll < this.lastScrollTop) {
				this.header.classList.add(this.headerSticky);
			}
			this.lastScrollTop = currentScroll;
			if (scrollPosition > 0) {
				this.header.classList.add(this.headerScroll);
			} else {
				this.header.classList.remove(this.headerScroll);
			}
		});
	},

	checkPage: function() {
		const currentLocation = location.href;
		const menuLength = this.navItems.length;
		for (let i = 0; i < menuLength; i++) {
			const navLink = this.navItems[i].querySelector('a');
			if (navLink.href === currentLocation) {
				this.navItems[i].classList.add('nav__item--current');
			}

			const subitemLinks = this.navItems[i].querySelectorAll(
				'.nav__subitem-links'
			);
			subitemLinks.forEach((subitemLink) => {
				const subLink = subitemLink.querySelector('a');
				if (subLink && subLink.href === currentLocation) {
					this.navItems[i].classList.add('nav__item--current');
					subitemLink.classList.add('nav__item--current');
				}
			});
		}

		this.primaryNavLink.forEach((link) => {
			if (this.href.includes(link.getAttribute('href'))) {
				const closestItem = link.closest('.nav__subitem-links');
				if (closestItem) {
					closestItem.classList.add('nav__item--current');
				}
			}
		});

		this.checkPageIfPageIsNotInNav();
	},

	checkPageIfPageIsNotInNav: function() {
		const subPages = location.pathname.split('/').filter((page) => page);
		if (subPages.length >= 2) {
			const firstParentHref = `/${subPages[0]}/`;
			const firstParentPage = this.nav.querySelector(`a[href="${firstParentHref}"]`);

			if (!firstParentPage) return;
			const navigationElement = firstParentPage.closest('.js-nav-item');

			navigationElement.classList.add('nav__item--current');
		}
	}
};

export default header;
